import React from 'react'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Badge from '@react/shared/ui/Badge'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

// A test point is one line of GitHub Markdown: rendered inline, inside its label.
const Inline = ({ text }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ p: ({ children }) => <>{children}</> }}>
    {text}
  </ReactMarkdown>
)

const Status = ({ point, busy }) => {
  if (busy) return <FontAwesomeIcon icon="circle-notch" spin className="text-[12px] text-slate-400" />
  if (!point.checked) return <Badge variant="soft" tone="neutral" size="sm">À valider</Badge>

  return (
    <Badge variant="soft" tone="success" size="sm" className="gap-1">
      <FontAwesomeIcon icon="check" className="text-[9px]" />
      {point.checked_by ? `Validé par ${point.checked_by}` : 'Validé'}
    </Badge>
  )
}

const Checklist = ({ points, saving = {}, onToggle }) => (
  <ul className="m-0 list-none divide-y divide-slate-100 overflow-hidden rounded-xl border-[1px] border-slate-200 p-0">
    {points.map(point => (
      <li key={point.index}>
        <label className="m-0 flex cursor-pointer items-start gap-3 px-[16px] py-2.5 text-[13.5px] font-normal leading-snug text-slate-700 transition hover:bg-slate-50">
          <input
            type="checkbox"
            checked={point.checked}
            disabled={saving[point.index]}
            onChange={(e) => onToggle(point, e.target.checked)}
            className="mt-px h-4 w-4 shrink-0 cursor-pointer accent-brand-500"
          />
          <span className="mt-px w-4 shrink-0 text-right text-[12px] tabular-nums text-slate-400">{point.index + 1}</span>
          <span className="min-w-0 flex-1 sm:flex sm:items-start sm:gap-3">
            <span className={clsx('tw-gh-markdown block sm:flex-1', point.checked && 'text-slate-500')}><Inline text={point.label} /></span>
            <span className="mt-1.5 block sm:mt-0 sm:shrink-0"><Status point={point} busy={saving[point.index]} /></span>
          </span>
        </label>
      </li>
    ))}
  </ul>
)

export default Checklist
